import type { Database, MediaType } from '@/types/database'
import { imageUrl } from '@/lib/images'

type MediaItem = Database['public']['Tables']['media_items']['Row']

// Launch content for the Learning Hub, provided by the client (22 Sep 2026).
// Used as a fallback when Supabase has no rows or is unavailable, so the
// section is populated even while the database is idle/paused.
export const staticMediaItems: MediaItem[] = [
  {
    id: 'static-read-2025-report',
    type: 'read',
    title: '2025 GIA Longevity Report',
    description:
      'Our flagship report on the state of aging and longevity, and the case for redesigning society for longer lives.',
    source: 'GIA Longevity',
    url: 'https://gialongevity.org/gia-longevity-publishes-its-2025-report-a-decisive-year-for-the-global-longevity-agenda/',
    thumbnail_url: imageUrl('media-report-2025', 'webp', 800),
    published_at: '2025-01-01',
    featured: true,
    created_at: '2026-09-22T00:00:00Z',
  },
  {
    id: 'static-watch-self-care',
    type: 'watch',
    title: 'The Art of Self-Care for Care Givers',
    description:
      'Practical strategies for caregivers to sustain their own wellbeing while caring for others.',
    source: 'YouTube',
    url: 'https://www.youtube.com/watch?v=FPwvKzdlaIo',
    thumbnail_url: 'https://img.youtube.com/vi/FPwvKzdlaIo/hqdefault.jpg',
    published_at: '2026-06-01',
    featured: true,
    created_at: '2026-09-22T00:00:00Z',
  },
  {
    id: 'static-watch-sustaining-caregiving',
    type: 'watch',
    title: 'Sustaining Caregiving Without Burning Out',
    description: 'A GIA Longevity conversation on caregiving that lasts.',
    source: 'GIA Longevity',
    url: 'https://www.youtube.com/watch?v=7j1eS2q_hxU',
    thumbnail_url: 'https://img.youtube.com/vi/7j1eS2q_hxU/hqdefault.jpg',
    published_at: '2026-05-01',
    featured: false,
    created_at: '2026-09-22T00:00:00Z',
  },
  {
    id: 'static-listen-designing-for-everyone',
    type: 'listen',
    title: 'Designing for Everyone: Accessibility as Innovation',
    description:
      'An episode of 4-Quarter Lives with Avivah Wittenberg-Cox on why accessible design drives innovation for all ages.',
    source: '4-Quarter Lives',
    url: 'https://podcasts.apple.com/us/podcast/4-quarter-lives/id1648152043?i=1000778020781',
    thumbnail_url: imageUrl('media-podcast-4ql', 'webp', 800),
    published_at: '2026-04-01',
    featured: true,
    created_at: '2026-09-22T00:00:00Z',
  },
]

export function staticMediaFor(type?: MediaType, limit?: number): MediaItem[] {
  const filtered = type
    ? staticMediaItems.filter((m) => m.type === type)
    : staticMediaItems
  return typeof limit === 'number' ? filtered.slice(0, limit) : filtered
}
